module.exports = __webpack_public_path__ + "static/Anders-Brotherus-a8297d70c55b5edef25f0f76cc0ac817.jpeg";